import React from 'react';
import LazyLoad from 'react-lazyload';

import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';
import './FeaturedSection.css';


class FeaturedItem extends React.Component {
  constructor(props) {
    super(props);
  }

  renderContent = () => {
    const { featuredItem, loggedInUser } = this.props;
    const clip = {
      clipUrl: featuredItem?.clipUrl,
      imageUrl: featuredItem?.imageUrl,
    };
    if (featuredItem?.clipUrl?.endsWith('null') || !featuredItem?.clipUrl) {

      return (
        <div className="content-item-thumbnail">
          <img alt="Xlthumb placeholder" src={featuredItem.thumbnailImageUrl ? featuredItem.thumbnailImageUrl : featuredItem.image} style={{ opacity: 1 }} />
        </div>
      );
    }

    return (
      <div className="content-featured-clip">
        <SimpleVideoPlayer
          autoPlayVideo={false}
          clip={clip}
          isFeaturedClip={true}
          videoClass={true}
          user={loggedInUser}
          fanZoneFreeVideo={loggedInUser !== undefined}
        />
      </div>
    );
  };

  render() {
    const { featuredItem, loggedInUser } = this.props;
    const title = featuredItem.name ? featuredItem.name : featuredItem.title;
    const URL = loggedInUser ? featuredItem.url : '/account/purchase';

    return (
      <div className="content-item-container">
        <a className="content-item " href={URL} title={title}>
          <LazyLoad offset={10}>
            {this.renderContent()}
          </LazyLoad>
          <div className="content-item-caption">
            <div className="content-item-category">
              {featuredItem.category}
            </div>
            <div className="content-item-title">
              {title}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default FeaturedItem;
